const createInstance = require('./create-instance-bundle.js')

module.exports = createInstance()
